import { Vec3D } from "./vec3d";
import { BBox3D } from "./bbox3d";
export var PropType;
(function (PropType) {
    PropType[PropType["Ball"] = 0] = "Ball";
})(PropType || (PropType = {}));
export class Prop {
    constructor(id) {
        this.position = new Vec3D();
        this.type = PropType.Ball;
        this.path = null;
        this.pathMillis = 0;
        this.diameter = 9;
        this.id = id;
    }
    getBoundingBox() {
        let box = new BBox3D();
        const r = this.diameter / 2;
        const min = new Vec3D(this.position.x - r, this.position.y - r, this.position.z - r);
        const max = new Vec3D(this.position.x + r, this.position.y + r, this.position.z + r);
        box.add(min);
        box.add(max);
        return box;
    }
}
